// extracted by mini-css-extract-plugin
module.exports = {"container":"about_container__fYQBx","row":"about_row__26mJI","column":"about_column__3w2HD","about-title":"about_about-title__2eaBc"};